'use client';

import { ProgressProvider } from '@bprogress/next/app';

/**
 * BProgress provider for App Router navigation progress bar
 * Automatically shows progress bar during route transitions
 */
export default function BProgressProvider() {
  return (
    <ProgressProvider
      color="#509156"
      height="3px"
      shallowRouting={false}
      options={{ showSpinner: false }}
    />
  );
}

